(() => {
  const queries = {dtf:['DTF Transfer'], premade:['Premade DTF Gang Sheet'], uv:['UV DTF Sticker Sheet','UV DTF Cup Wrap','UV DTF Transfer']};
  const normalize = text => text.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-directory-grid]');
    const search = root.querySelector('[data-directory-search]');
    const sort = root.querySelector('[data-directory-sort]');
    const empty = root.querySelector('[data-directory-empty]');
    const status = root.querySelector('[data-directory-status]');
    const buttons = [...root.querySelectorAll('[data-directory-family]')];
    const controls = root.querySelector('[data-directory-controls]');
    let cards = [...grid.children], family = 'all', timer, frame, partial = false;
    const sortCards = () => {
      cards.sort((a,b) => {
        const names = a.dataset.name.localeCompare(b.dataset.name,undefined,{numeric:true,sensitivity:'base'});
        return sort.value === 'count' ? Number(b.dataset.count)-Number(a.dataset.count) || names : sort.value === 'za' ? -names : names;
      });
      const fragment = document.createDocumentFragment(); cards.forEach(card => fragment.append(card)); grid.append(fragment);
    };
    function apply(save = false) {
      const terms = normalize(search.value).split(/\s+/).filter(Boolean);
      let count = 0;
      cards.forEach(card => {
        const match = (empty.checked || Number(card.dataset.count)>0) && (family === 'all' || card.dataset.families.includes('|' + family + '|')) && terms.every(term => normalize(card.dataset.search).includes(term));
        card.hidden = !match;
        if (match) count++;
        const link = card.querySelector('a');
        link.href = card.querySelector('a').dataset.baseUrl + (queries[family] ? '?' + queries[family].map(type => 'filter.p.product_type=' + encodeURIComponent(type)).join('&') : '');
        card.querySelector('[data-directory-card-count]').hidden = family !== 'all';
      });
      buttons.forEach(button => {
        button.setAttribute('aria-pressed',String(button.dataset.directoryFamily === family));
        button.hidden = button.dataset.directoryFamily !== 'all' && !cards.some(card => card.dataset.families.includes('|' + button.dataset.directoryFamily + '|'));
      });
      const label = buttons.find(button => button.dataset.directoryFamily === family)?.textContent || '';
      status.textContent = count + (count === 1 ? ' collection' : ' collections') + (family !== 'all' ? ' · ' + label : '') + (search.value.trim() ? ' matching “' + search.value.trim() + '”' : '') + (partial ? ' · Search covers loaded collections; more are available through the page links below.' : '');
      root.querySelector('[data-directory-no-results]').hidden = count !== 0;
      if (save) {
        const hash = new URLSearchParams();
        if (family !== 'all') hash.set('family',family);
        if (search.value.trim()) hash.set('q',search.value.trim());
        if (empty.checked) hash.set('empty','1');
        if (sort.value !== 'az') hash.set('sort',sort.value);
        history.replaceState(null,'',location.pathname + location.search + (hash.size ? '#' + hash.toString() : ''));
      }
    }
    const readHash = () => {
      const state = new URLSearchParams(location.hash.slice(1));
      family = buttons.some(button => button.dataset.directoryFamily === state.get('family')) ? state.get('family') : 'all';
      search.value = state.get('q') || ''; empty.checked = state.get('empty') === '1';
      sort.value = ['az','za','count'].includes(state.get('sort')) ? state.get('sort') : 'az'; sortCards(); apply();
    };
    buttons.forEach(button => button.addEventListener('click',() => { family = button.dataset.directoryFamily; apply(true); }));
    search.addEventListener('input',() => { clearTimeout(timer); timer = setTimeout(() => apply(true),120); });
    sort.addEventListener('change',() => { sortCards(); apply(true); });
    empty.addEventListener('change',() => apply(true));
    root.querySelector('[data-directory-clear]').addEventListener('click',() => { search.value = ''; apply(true); search.focus(); });
    root.querySelector('[data-directory-reset]').addEventListener('click',() => { search.value = ''; family = 'all'; empty.checked = false; sort.value = 'az'; sortCards(); apply(true); search.focus(); });
    window.addEventListener('hashchange',readHash);
    const header = document.querySelector('.t4s-section-header');
    const offset = () => {
      frame = null; const rect = header?.getBoundingClientRect();
      root.style.setProperty('--s2t-dir-header-offset',(rect && rect.top <= 1 ? Math.max(0,Math.ceil(rect.bottom)) : 0) + 'px');
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(offset); };
    const observer = new ResizeObserver(schedule); if (header) observer.observe(header);
    window.addEventListener('scroll',schedule,{passive:true}); window.addEventListener('resize',schedule); header?.addEventListener('transitionend',schedule);
    controls.hidden = false; root.querySelector('[data-directory-options]').hidden = false; readHash(); offset();
    // Keep every collection searchable if the directory eventually exceeds Shopify's 250-item page size.
    const pagination = root.querySelector('[data-directory-pagination]');
    const controller = new AbortController();
    async function loadRemaining() {
      if (!pagination) return;
      const loaded = new Set(cards.map(card => card.querySelector('a').dataset.baseUrl));
      let next = new URL(location.pathname,location.origin), visited = new Set();
      try {
        while (next && !visited.has(next.href)) {
          visited.add(next.href); next.searchParams.set('section_id',root.dataset.sectionId);
          const response = await fetch(next,{signal:controller.signal}); if (!response.ok) throw new Error('Directory unavailable');
          const doc = new DOMParser().parseFromString(await response.text(),'text/html');
          const found = doc.querySelector('[data-directory-grid]'); if (!found) throw new Error('Directory missing');
          found.querySelectorAll('[data-directory-card]').forEach(card => { const key = card.querySelector('a').dataset.baseUrl; if (!loaded.has(key)) { loaded.add(key); grid.append(document.importNode(card,true)); } });
          const link = doc.querySelector('[data-directory-next]'); next = link ? new URL(link.getAttribute('href'),location.origin) : null;
          if (next && next.origin !== location.origin) throw new Error('Unexpected directory URL');
        }
        pagination.hidden = true;
      } catch (error) { if (error.name === 'AbortError') return; partial = true; }
      cards = [...grid.children]; sortCards(); apply();
    }
    loadRemaining();
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload',() => {
      controller.abort(); observer.disconnect(); clearTimeout(timer); if (frame) cancelAnimationFrame(frame);
      window.removeEventListener('hashchange',readHash); window.removeEventListener('scroll',schedule); window.removeEventListener('resize',schedule); header?.removeEventListener('transitionend',schedule);
    },{once:true});
  }
  const scan = () => document.querySelectorAll('[data-s2t-directory]').forEach(init);
  scan(); document.addEventListener('shopify:section:load',scan);
})();
